import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Billing Information", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "As shown in your credit card", -1)
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, " First Name* ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, " Second Name* ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, " Address* ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, " Address Line 2 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " Country* ", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, " State ", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, " City* ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, " Postcode / ZIP code* ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "/sitemedia/Spellingframe_Terms_and_Conditions_FULL_v1.pdf",
  target: "sf_tos"
}, "terms and conditions", -1)
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PurchaseResume = _resolveComponent("PurchaseResume")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PurchaseResume, {
      mode: _ctx.mode,
      "school-reference": _ctx.schoolReference,
      "purchase-data": _ctx.purchaseData
    }, null, 8, ["mode", "school-reference", "purchase-data"]),
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("fieldset", {
          disabled: _ctx.status == 2
        }, [
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_first_name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fields.sage_first_name) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fields.sage_first_name.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.formData.fields.sage_first_name.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_last_name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fields.sage_last_name) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.fields.sage_last_name.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.formData.fields.sage_last_name.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_address1,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.fields.sage_address1) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fields.sage_address1.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.formData.fields.sage_address1.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_address2,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.fields.sage_address2) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.fields.sage_address2.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.formData.fields.sage_address2.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_country,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.fields.sage_country) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.fields.sage_country.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.id,
                    value: c.countryCode
                  }, _toDisplayString(c.countryName), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.formData.fields.sage_country.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.formData.fields.sage_country.value == 'US')
            ? (_openBlock(), _createBlock(_component_FormInput, {
                key: 0,
                modelValue: _ctx.formData.fields.sage_state,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.fields.sage_state) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.fields.sage_state.value) = $event)),
                    class: "sf-form-control tw-w-full"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usStateOptions, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.id,
                        value: s.code
                      }, _toDisplayString(s.name), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.formData.fields.sage_state.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_city,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.fields.sage_city) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.fields.sage_city.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.formData.fields.sage_city.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_postcode,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.fields.sage_postcode) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.fields.sage_postcode.value) = $event)),
                class: "sf-form-control tw-w-full"
              }, null, 512), [
                [_vModelText, _ctx.formData.fields.sage_postcode.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.formData.fields.sage_terms,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.fields.sage_terms) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.fields.sage_terms.value) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData.fields.sage_terms.value]
                ]),
                _createTextVNode(" I have read, understood, and agree to the "),
                _hoisted_14
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 8, _hoisted_3),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            disabled: !_ctx.formData.fields.sage_terms.value,
            class: "sf-btn-primary"
          }, " Purchase ", 8, _hoisted_15),
          (_ctx.invoiceId)
            ? (_openBlock(), _createBlock(_component_SfRouterLink, {
                key: 0,
                to: "/dashboard",
                class: "sf-btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }))
            : (_ctx.showModify)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.$emit('modify')), ["prevent"])),
                  class: "sf-btn-secondary"
                }, " Modify "))
              : _createCommentVNode("", true)
        ])
      ], 32)
    ])
  ]))
}